import { Box, Container, Divider, List, ListItem, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useInnsynContext } from '../../context/InnsynContextProvider'
import { EarTagListItem } from '../../components/EarTagListItem'
import { FormattedMessage } from 'react-intl'
import NavigationHeader from '../../components/NavigationHeader'
import { useNavigate } from 'react-router-dom'
import { INNSYN_SEARCH_PATH } from '../../paths'

export const SavedEarTags = () => {
    const { merker } = useInnsynContext()
    const [favoriteIDs, setFavoriteIDs] = useState<string[]>([])
    const [personer, setPersoner] = useState<Person[]>()
    const [merkeSaker, setMerkeSaker] = useState<Merke[]>([])
    const { fetchPersonerMedMerke, brukerInformasjon } = useInnsynContext()
    const navigate = useNavigate()

    const getPersonerForMerker = async (merkerListe: Merke[] | undefined) => {
        if (
            merkerListe !== undefined &&
            merkerListe.length <= 10 &&
            brukerInformasjon?.harTilgang
        ) {
            const sakIdListe = merkerListe.map((merke) => merke.id.toString())
            const personRes = await fetchPersonerMedMerke(sakIdListe)
            setPersoner(personRes)
        }
    }

    const findPersonNameForMerkesak = (merke: Merke) => {
        const person = personer?.find((pers) => merke.id === pers.id)
        if (merkeSaker.length > 10) {
            return
        }
        if (person?.organisasjon?.orgnr) {
            return `${person?.organisasjon.orgnavn} ${person?.organisasjon.orgnr}`
        }
        if (person?.personnavn?.etternavn || person?.personnavn?.fornavn) {
            return `${person?.personnavn.fornavn} ${person?.personnavn.etternavn}`
        }
    }

    useEffect(() => {
        const currentStorage = localStorage.getItem(
            'reinmerker-innsyn-favoritter-v1'
        )
        if (currentStorage) {
            setFavoriteIDs(currentStorage.split('&'))
        }
    }, [])

    useEffect(() => {
        if (!merker || merker.length <= 0) return
        if (!favoriteIDs || favoriteIDs.length <= 0) return
        setMerkeSaker(
            merker?.filter((merke) =>
                favoriteIDs.some((favID) => merke.id === parseInt(favID))
            ) || []
        )
    }, [merker, favoriteIDs])

    useEffect(() => {
        if (!merkeSaker || merkeSaker.length <= 0) return
        // Business decision: Show names only if 10 or fewer results.
        if (merkeSaker.length > 10) return
        getPersonerForMerker(merkeSaker)
    }, [merkeSaker])

    return (
        <Container sx={{ paddingTop: '0.25rem' }}>
            <NavigationHeader
                onClickBack={() => navigate(INNSYN_SEARCH_PATH)}
            />
            <Stack sx={{ marginTop: '0.75rem' }}>
                <Box sx={{ fontSize: '1.25rem' }}>
                    {' '}
                    <FormattedMessage
                        id={'saved-eartags.title'}
                        values={{ count: merkeSaker.length }}
                    />
                </Box>
                {merkeSaker.length === 0 ? (
                    <Stack sx={{ textAlign: 'center', marginTop: '10rem' }}>
                        <FormattedMessage id='saved-eartags.no-tags' />
                    </Stack>
                ) : (
                    <List>
                        {merkeSaker.map((merke, index) => (
                            <div key={`result-list-${index}`}>
                                <ListItem sx={{ justifyContent: 'center' }}>
                                    <EarTagListItem
                                        id={merke.id}
                                        navn={findPersonNameForMerkesak(merke)}
                                    />
                                </ListItem>
                                <Divider />
                            </div>
                        ))}
                    </List>
                )}
            </Stack>
        </Container>
    )
}

export default SavedEarTags
